import { EcommerceService } from 'services'

export default class ContactService extends EcommerceService {
  register(payload: any) {
    const req = this.setUrl('/mail/send').post(payload)
    return req
  }
}
